/* eslint-disable react-hooks/exhaustive-deps */
import { useFormik } from 'formik'
import { updateMap } from 'map-creator'
import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { PointMapForm as View } from 'ui-components'
import { useAuth } from 'user-auth'
import { getMapThumbnailLink } from 'utils'
import * as Yup from 'yup'

import { uploadMapThumbnail } from '~map-preview/api/uploadMapThumbnail'
import { DeleteButton } from '~map-preview/App/Tools/MapDataSettingsDrawer/Map/DeleteButton'
import { useCaptureMapThumbnail } from '~map-preview/hooks/useCaptureMapThumbnail'
import { setMapData, useMap } from '~map-preview/states/map'
import { closeMapDataSettingsDrawer } from '~map-preview/states/ui'
import { UpdateMapInput } from '~map-preview/types/__generated/gql/graphql'

export const Map = (props) => {
  const dispatch = useDispatch()
  const timeId = useRef<NodeJS.Timeout | null>(null)
  const map = useMap()
  const { user } = useAuth()

  const form = useFormik({
    initialValues: {
      name: '',
      thumbnail: '',
      workspaceId: map.workspace.id
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required('Name is required'),
      thumbnail: Yup.string().required('Thumbnail is required')
    }),
    onSubmit: async (values, helpers) => {
      if (!user) throw new Error('Must be logged in')

      const { name, thumbnail, workspaceId } = values

      if (thumbnail.startsWith('blob:')) {
        await uploadMapThumbnail({
          mapId: map.id,
          blobPath: thumbnail
        })
      }

      const input: Partial<UpdateMapInput> = {
        id: map.id,
        name,
        dataId: map.dataId,
        workspaceId
      }
      const updatedMap = await updateMap(input)
      dispatch(setMapData({ ...map, ...updatedMap }))
      dispatch(closeMapDataSettingsDrawer())

      helpers.resetForm()
    }
  })

  const mapThumbnail = useCaptureMapThumbnail()

  useEffect(() => {
    if (!map || !Object.keys(map).length) return

    form.setValues({
      name: map.name,
      thumbnail: getMapThumbnailLink(map),
      workspaceId: map.workspace.id
    })
  }, [map])

  useEffect(() => {
    if (mapThumbnail) {
      if (timeId.current) clearTimeout(timeId.current)
      timeId.current = setTimeout(() => {
        console.log('setting thumbnail')
        form.setFieldValue('thumbnail', mapThumbnail)
      }, 500)
    }
  }, [mapThumbnail])

  return (
    <View
      {...props}
      form={form}
      slots={{
        DeleteButton
      }}
    />
  )
}
